$("#app-loading").addClass("loaded");
